import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import { filterCaseInsensitive } from "../../services/helpers/table";

const AdminStockMovementTable = props => {
    const columns = [{
        Header: 'SKU',
        accessor: 'sku',
    },{
        Header: 'TANGGAL',
        accessor: 'date',
    },{
        Header: 'BARANG KELUAR / MASUK',
        accessor: 'quantity',
        Cell: ({row,original}) => qtyCell(original)
    }];

    const qtyCell = (og) => {
        return (
            <div className={`badge ${og.quantity > 0 ? 'badge-success' : 'badge-danger'}`}>
                <b>{og.quantity}</b><br/>
            </div>
        )
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={10}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminStockMovementTable;